import { useProcessActions } from '@hooks/useProcessActions';
import type { ReactNode } from 'react';
import { NavLink, useLocation } from 'react-router';
import { type NavItem, navItems } from './nav.config';

import './Nav.css';

export default function Nav(): ReactNode {
	const location = useLocation();
	const { startNewAnalysis, status } = useProcessActions();

	const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
		if (status === 'processing' || status === 'completed' || status === 'error') {
			e.preventDefault();
			startNewAnalysis();
		}
	};

	return (
		<nav id="main-nav">
			<ul>
				{navItems.map((item: NavItem) => {
					const isCurrentlyActive = location.pathname === item.path;
					return (
						<li key={item.path}>
							<NavLink to={item.path} onClick={handleNavClick} className={() => `nav-link ${isCurrentlyActive ? 'active' : ''}`}>
								<img src={isCurrentlyActive ? item.enabledIcon : item.disabledIcon} alt={item.altText} />
							</NavLink>
						</li>
					);
				})}
			</ul>
		</nav>
	);
}
